export { default } from "./borders.mjs";
export * from "./borders.mjs";